import { render, staticRenderFns } from "./refund-policy-kr.component.vue?vue&type=template&id=26067b5a&scoped=true"
import script from "./refund-policy-kr.component.ts?vue&type=script&lang=ts&external"
export * from "./refund-policy-kr.component.ts?vue&type=script&lang=ts&external"
import style0 from "./refund-policy-kr.component.vue?vue&type=style&index=0&id=26067b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26067b5a",
  null
  
)

export default component.exports